import { openOverlay, closeOverlay } from './SearchOverlay'

export const initialise = () => {
    const banner = document.querySelector<HTMLDivElement>('.banner-geolocation-overlay')
    if (!banner) return

    const overlay = document.querySelector<HTMLDialogElement>('#dialog-geolocation-overlay')
    if (!overlay) return

    const buttonClose = overlay.querySelector<HTMLButtonElement>('.dialog-geolocation-overlay__button-close')
    if (!buttonClose) return

    const key = sessionStorage?.getItem('showGeolocationOverlay')
    if (key) return

    sessionStorage.setItem('showGeolocationOverlay', 'true')

    setTimeout(() => {
        openOverlay(overlay)
    }, 1000)

    buttonClose.addEventListener('click', () => {
        closeOverlay(overlay)
    })
}
